import React from 'react';
import Colors from '../../Colors';
import GeneralDialog from '../../GeneralDialog';
import HelpIcon from '../../HelpIcon';
import Select from '../../../components/engine/SelectEngine';
import styled from 'styled-components/macro';
import { TextString } from '../../../components/Text';

const H3 = styled.h3`
  margin: 0;
  font-size: 14px;
  color: #000;

  &:after {
    content: '${({ required }) => (required ? ' *' : '')}';
    color: ${Colors.OT_RED};
    font-size: 20px;
  }
`;

const SelectContainer = styled.div`
  margin-bottom: 0;
  margin-top: 3rem;
`;

const LabelContainer = styled.span`
  color: #000;
`;

const InstructionContainer = styled.div`
  font-size: 14px;
`;

const StyledSelect = styled(Select)`
  input {
    font-size: 14px;
  }
`;

const LookupSettingsPanelView = ({
  clickedSave = () => {},
  entityType,
  fieldOptions = [],
  forms = [],
  saveDisabled,
  selectedField = null,
  setSelectedField = () => {},
  selectedSubFields = [],
  setSelectedSubFields = () => {},
  selectedUserGroups = [],
  setSelectedUserGroups = () => {},
  selectedForm = null,
  setSelectedForm = () => {},
  showLookupDialog,
  setShowLookupDialog,
  step2Disabled,
  step3Disabled,
  subFieldOptions = [],
  ...props
}) => {
  return (
    <GeneralDialog
      titleBlockProps={{
        $customCSS: `background: ${Colors.PRIMARY}; h2 {color:#fff;}`
      }}
      customCSS={`svg[id='close-dialog'] {color: #fff;}`}
      buttons={[
        {
          text: 'forms.field_type.lookup_save',
          onClick: () => {
            clickedSave();
          },
          disabled: saveDisabled
        }
      ]}
      disableBackdropClick
      handleClose={() => setShowLookupDialog(false)}
      handleConfirm={() => clickedSave}
      maxWidth="sm"
      open={showLookupDialog}
      title={
        entityType === 'user'
          ? 'forms.field_type.user_lookup'
          : 'forms.field_type.lookup'
      }
    >
      {entityType === 'form' ? (
        <>
          <H3>
            <TextString content="forms.field.lookup.question" />
          </H3>
          <InstructionContainer>
            <TextString content="forms.field.lookup.answer" />
          </InstructionContainer>
          <SelectContainer>
            <StyledSelect
              fullWidth
              data-testid="form-selector"
              value={selectedForm}
              label={
                <LabelContainer>
                  <strong>
                    <TextString content="forms.field.lookup.step1" />{' '}
                  </strong>
                  <TextString content="forms.field.lookup.form_placeholder" />
                  <HelpIcon title="forms.field.lookup.help1" />
                </LabelContainer>
              }
              placeholder="forms.field.lookup.form_placeholder"
              searchable
              onChange={setSelectedForm}
              options={forms.map(form => ({
                value: form.id,
                text: form.title,
                'data-testid': `form-selector-${form.id}`
              }))}
              required
            />
          </SelectContainer>
          <SelectContainer>
            <StyledSelect
              fullWidth
              data-testid="field-selector"
              value={selectedField}
              label={
                <LabelContainer>
                  <strong>
                    <TextString content="forms.field.lookup.step2" />{' '}
                  </strong>
                  <TextString content="forms.field.lookup.key_placeholder" />
                  <HelpIcon title="forms.field.lookup.help2" />
                </LabelContainer>
              }
              placeholder="forms.field.lookup.key_placeholder"
              searchable
              onChange={setSelectedField}
              options={fieldOptions.map(field => ({
                value: field.internalId,
                text: field.title,
                'data-testid': `field-selector-${field.id}`,
                isSectionBreak: field.uiType === 'section_break'
              }))}
              disabled={step2Disabled}
            />
          </SelectContainer>
        </>
      ) : (
        ''
      )}
      {entityType === 'user' ? (
        <>
          <H3>
            <TextString content="forms.field.user_lookup.question" />
          </H3>
          <InstructionContainer>
            <TextString content="forms.field.user_lookup.answer" />
          </InstructionContainer>
        </>
      ) : (
        ''
      )}
      <SelectContainer>
        <StyledSelect
          fullWidth
          allowMultiSelect
          data-testid="subfield-selector"
          value={selectedSubFields}
          label={
            <LabelContainer>
              {entityType === 'form' ? (
                <strong>
                  <TextString content="forms.field.lookup.step3" />{' '}
                </strong>
              ) : (
                ''
              )}
              <TextString content="forms.field.lookup.sub_placeholder" />
              <HelpIcon
                title={
                  entityType === 'user'
                    ? 'forms.field.lookup.user_help'
                    : 'forms.field.lookup.help3'
                }
              />
            </LabelContainer>
          }
          placeholder="forms.field.lookup.sub_placeholder"
          searchable
          onChange={setSelectedSubFields}
          options={subFieldOptions.map(field => ({
            value: field.internalId,
            text: field.title,
            'data-testid': `subfield-selector-${field.id}`,
            isSectionBreak: field.uiType === 'section_break'
          }))}
          disabled={step3Disabled}
        />
      </SelectContainer>
      {entityType === 'user' ? (
        <SelectContainer>
          <StyledSelect
            fullWidth
            allowMultiSelect
            data-testid="usergroup-selector"
            value={selectedUserGroups}
            label={
              <LabelContainer>
                <TextString content="forms.field.lookup.user_groups" />
              </LabelContainer>
            }
            placeholder="forms.field.lookup.user_groups"
            searchable
            onChange={setSelectedUserGroups}
            options={props.userGroups.map(one => ({
              value: one.id,
              text: one.code,
              'data-testid': `usergroup-selector-${one.id}`
            }))}
          />
        </SelectContainer>
      ) : (
        ''
      )}
    </GeneralDialog>
  );
};

export default LookupSettingsPanelView;
